<template>
  <b-overlay
    :show="show && !$store.state.auth.isProfileCalled"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <GetDescription name="top-dashboard-description" />

    <div v-if="!show && $store.state.auth.isProfileCalled">
      <b-row class="d-flex flex-wrap flex-column justify-content-center align-items-center">
        <b-col
          md="12"
          sm="12"
          class="mt-1 d-flex flex-wrap justify-content-center"
        >
          <div style="height: 100%;">
            <b-alert
              class="p-2 pb-4"
              style="height: 100%;position: relative;"
              show
              variant="warning"
            >
              <h4> {{ $t('suggest-active-two-factore-login-message') }}</h4>
              <p />
              <br>
              <br>
              <div
                class="w-100 text-center mt-2"
                style="position: absolute;bottom: 10px; width: max-content;"
              >
                <b-button
                  class="mx-auto d-block w-50 w-md-25"
                  :to="'/'+this.$i18n.locale+'/profile/security'"
                >
                  {{ $t('activate') }}
                </b-button>
              </div>
            </b-alert>
          </div>
          <div
            v-for="card in cardsArray"
            :key="card.title"
            :class="(card.total_pending && card.total_pending !=0 )||( card.cardType && card.cardType == 'document' &&
              (card.status == 'pending' || card.status == 'rejected'))?'w-100 w-md-50 p-1':''"
          >
            <div
              v-if="(card.total_pending && card.total_pending !=0 )||( card.cardType && card.cardType == 'document' &&
                (card.status == 'pending' || card.status == 'rejected'))"
              class="w-100"
              style="position: relative;height: 100%;"
            >
              <div style="height: 100%;">
                <b-alert
                  class="p-2 pb-4"
                  style="height: 100%;position: relative;"
                  show
                  :variant="(card.cardType && card.cardType == 'document')?(card.status == 'pending'?'warning':'danger'):'info'"
                >
                  <h4>
                    {{ $t(card.title,{count:card.total_pending?card.total_pending:'',status:$t(card.status)}) }}
                  </h4>
                  <p :class="$store.state.appConfig.layout.skin === 'dark' && !(card.cardType && card.cardType == 'document') && 'text-white'">
                    {{ $t(card.cardType && card.cardType == 'document'?(card.status == 'pending'?card.pendingDescription:card.rejectDescription):card.description) }}
                  </p>
                  <div
                    class="w-100 text-center mt-2"
                    style="position: absolute;bottom: 10px; width: max-content;"
                  >
                    <router-link
                      :to="card.link"
                    >
                      <b-button variant="success">
                        {{ $t('more_details') }}
                      </b-button>
                    </router-link>
                  </div>
                </b-alert>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row
        v-if="isUserActive && !user_complete"
        class="d-flex flex-wrap flex-column justify-content-center align-items-center"
      >
        <b-col
          md="8"
          sm="12"
          class="mt-1"
        >
          <b-card style="height:100%">
            <b-card-body class="p-0 card-center-content">
              <h4>{{ $t(cardInfo.nextStep.header) }}</h4>
              <p>{{ $t(cardInfo.nextStep.description) }}</p>
            </b-card-body>
            <div class="text-center">
              <b-button
                class="p-2 px-4"
                variant="success"
                :to="cardInfo.nextStep.btn_link"
              >
                {{ $t(cardInfo.nextStep.btn_text) }}
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="isUserActive && user_complete && mergedObj.document&&( mergedObj.document.general.status != 'rejected' && mergedObj.document.general.status != 'pending') ">
        <b-col
          md="8"
          sm="12"
          class="mt-1 mx-auto"
        >
          <b-card style="height:100%">
            <b-card-body class="p-0 card-center-content">
              <h2>{{ $t('dashboard_page.user_complete_message') }}</h2>
              <p>{{ $t('dashboard_page.use_platform') }}</p>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </b-overlay>
</template>
<script>
import DashboardCompany from '@/views/logics/dashboard/DashboardCompany'

export default {
  mixins: [DashboardCompany],
}
</script>
<style>
.card-center-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.buy-sell-btn{
  background-color: #f0c72b !important;
  border: none;
  color: #000 !important;
  animation: shake 10s infinite;
  animation-delay: 2s;

}
@keyframes shake {
  0% {
    transform: scale(1);
  }

  1% {
    transform: scale(1.2);
  }

  2% {
    transform: scale(1);
  }

  3% {
    transform: scale(1);
  }

  75% {
    transform: scale(1);
  }

  100% {
    transform: scale(1);
  }
}

.buy-sell-btn:focus {
  background-color:#f0c72b !important ;
}
</style>
